module.exports = __webpack_public_path__ + "img/205-switzerland.a32cf2cf.svg";